import { Text } from "@chakra-ui/react";

/**
 * Component for displaying styled text in lists
 * @param {Object} props - Component props
 * @param {string} props.title - The text content to display
 * @param {Object} props.style - Chakra UI style object for customizing text appearance
 * @see src/components/companies/companiesList/newCompaniesList/viewListTools/shared/RecomendedViews.tsx
 */
const ListText = ({ 
  title, 
  style 
}: { 
  title: string; 
  style?: Record<string, string | number | boolean | undefined | null | Record<string, unknown>>; 
}) => {
  return (
    <Text
      fontSize={"14px"}
      fontWeight={"700"}
      lineHeight={"1.2"}
      letterSpacing={"2%"}
      {...style}
    >
      {title}
    </Text>
  );
};

export default ListText;
